import { render, staticRenderFns } from "./packdetail.vue?vue&type=template&id=bf26b00c"
import script from "./packdetail.vue?vue&type=script&lang=js"
export * from "./packdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports